<template>
  <div v-if="report">
      <div class="bg-grey-blue p-3 rounded">
        <FormulateForm v-model="formValues"
                       :errors="formErrors">
          <ifac-report-form :report="report"
                            :can-update="report.can.update"
                            :schema="formSchema"/>
        </FormulateForm>
      </div>
      <div class="row submit-buttons">
        <div class="col text-right right-col p-0">
          <button
            v-if="report.can.update"
            type="submit"
            class="btn btn-secondary"
            @click="mx_update(report)"
          >
            Save
          </button>
          <button
            v-if="report.can.update"
            type="submit"
            class="btn btn-primary"
            :disabled="report.can.submit === false"
            @click="mx_submit(report)"
          >
            Submit report
          </button>
        </div>
      </div>
  </div>
  <ifac-loader v-else style="height: 110px"/>
</template>

<script>
import reportsMixin from '@/mixins/awards/reports.mixin';
import { IfacLoader, IfacReportForm } from '@ifac/ui';

export default {
  components: {
    IfacLoader,
    IfacReportForm,
  },
  mixins: [reportsMixin],
  props: {
    type: {
      type: String,
    },
    reportable: {
      type: Object,
    },
  },
  name: 'EditReport',
  async created() {
    this.fetchReports();
  },
  data() {
    return {
      report: null,
      formSchema: [],
      formValues: {},
      formErrors: {},
    };
  },
  methods: {
    initForm() {
      if (this.report) {
        this.formSchema = this.report.form_schema;
        this.formValues = this.report.form_values ?? {};
        this.formErrors = {};
      }
    },
    fetchReports() {
      this.report = null;
      if (this.type === 'award') {
        this.mx_fetchAwardReports(this.reportable).then((response) => {
          const [report] = response.data.data;
          this.report = report;
          this.initForm();
        });
      }

      if (this.type === 'nomination') {
        this.mx_fetchNominationReports(this.reportable).then((response) => {
          const [report] = response.data.data;
          this.report = report;
          this.initForm();
        });
      }
    },
  },
  watch: {
    reportable() {
      this.initForm();
      this.fetchReports();
    },
  },
};
</script>
